import React from "react";

function Icon(props) {

	let svg;

	/* Load corresponding SVG */
	if(props.icon) {
		svg = require("../../../assets/icons/" + props.icon + ".svg");
	}

	const { size, color, className, onClick } = props;
	const classes = `icon icon--${size} icon--${color} ${className}`;

	return (
		<span
			className={classes}
			dangerouslySetInnerHTML={{__html: svg}}
			onClick={onClick} />
	);
}

Icon.defaultProps = {
	size: "medium",
	color: "",
	classes: ""
};

export default Icon;



// WEBPACK FOOTER //
// ./src/js/common/components/Icon.js